/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientBasicModel { 
    id: number;
    createDate: string;
    phone: string;
    fullname?: string;
    birthDate?: string;
    email?: string;
    countryId?: number;
}

